import React from 'react';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    name: 'Sarah M.',
    location: 'Bondi',
    rating: 5,
    text: 'Absolutely incredible work! The team turned up on time, were super professional, and my car has never looked better. Highly recommend ProClean for anyone in Sydney.'
  },
  {
    id: 2,
    name: 'James K.',
    location: 'Parramatta',
    rating: 5,
    text: 'Booked the Full Detail package and I was blown away. The interior looks brand new and the exterior shines like a showroom car. Worth every dollar.'
  },
  {
    id: 3,
    name: 'Priya R.',
    location: 'North Sydney',
    rating: 5,
    text: 'Loved the convenience of having them come to my office. Quality is top-notch and pricing was very reasonable. Will be a repeat customer for sure!'
  },
  {
    id: 4,
    name: 'Marcus T.',
    location: 'Cronulla',
    rating: 5,
    text: 'The Deluxe Showroom package is unreal. Ceramic coating + clay bar treatment had my Range Rover looking better than the day I bought it. 10/10.'
  },
  {
    id: 5,
    name: 'Emily L.',
    location: 'Surry Hills',
    rating: 5,
    text: 'Friendly, on time, and the result was spotless. Pet hair gone, stains gone, smelled amazing. Best mobile detailer I have ever used in Sydney.'
  },
  {
    id: 6,
    name: 'David W.',
    location: 'Hurstville',
    rating: 5,
    text: 'These guys are the real deal. Steam clean carpets, leather conditioning, the lot. My car looks like new again. Booking them every month now.'
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-white to-slate-50 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <div className="inline-flex items-center px-4 py-1.5 bg-blue-50 border border-blue-100 rounded-full mb-6">
            <Star className="w-4 h-4 text-yellow-500 fill-yellow-500 mr-2" />
            <span className="text-sm font-semibold text-blue-700">5-Star Reviews</span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 mb-6 leading-tight">
            Loved by Sydney <span className="text-blue-600">drivers.</span>
          </h2>
          <div className="flex items-center justify-center gap-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-6 h-6 text-yellow-500 fill-yellow-500" />
            ))}
            <span className="text-slate-600 font-semibold ml-2">5.0 from 500+ customers</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              className="group bg-white p-7 rounded-3xl border border-slate-100 hover:border-blue-200 hover:shadow-2xl hover:shadow-blue-100/50 transition-all duration-300 hover:-translate-y-1 relative"
            >
              <Quote className="absolute top-5 right-5 w-10 h-10 text-blue-100 group-hover:text-blue-200 transition-colors" />
              <div className="flex gap-1 mb-4">
                {[...Array(t.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed mb-6 relative z-10">"{t.text}"</p>
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                  {t.name.split(' ').map(n => n[0]).join('')}
                </div>
                <div>
                  <div className="font-bold text-slate-900 text-sm">{t.name}</div>
                  <div className="text-slate-500 text-xs">{t.location}, Sydney</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
